import { Button, TableProps } from "antd";
import { Link, useParams } from "react-router-dom";
import { useAppSelector } from "../../../../app/store";
import TitleBar from "../../../../components/common/TitleBar";
import CustomTable from "../../../../components/ui/CustomTable";
import { useGetSurveyResponsesQuery } from "../../../../features/organization/survey/surveyApi";
import useError from "../../../../hooks/useError";
import useTable from "../../../../hooks/useTable";
import SidebarLayout from "../../../../layouts/SidebarLayout";
import { countParPageSerialNumber } from "../../../../utils/number";
import { valueOrNa } from "../../../../utils/string";
import { addKeyInArray } from "../../../../utils/utils";

// const STATUS_CONFIG = {
//   pending: "status status-warning",
//   accepted: "status status-success",
//   reject: "status status-danger",
// };

type TableStatus = {
  status: string;
};

export default function SurveyDataDetails() {
  const { id } = useParams();
  const businessId = useAppSelector((state) => state.auth.user?.business_id);

  const { page, limit, filter, keyword, handleLimit, handlePagination } =
    useTable<TableStatus>();
  const { data, isError, isLoading, isFetching, error } =
    useGetSurveyResponsesQuery(
      {
        params: {
          business_id: businessId as number,
          survey_template_id: id as string,
          search: keyword,
          ...filter,
        },
      },
      { skip: !businessId }
    );
  const surveyData = data?.data?.users;

  useError(isError, error, "Survey data get fail");

  const columns: TableProps<any>["columns"] = [
    {
      title: "#SL",
      align: "center",
      width: 60,
      render: (_, __, index) => countParPageSerialNumber(page, limit, index),
    },
    {
      title: "Bondhu ID",
      dataIndex: "business_member",
      render: (val) => valueOrNa(val?.id),
    },
    {
      title: "Bondhu Name",
      dataIndex: "business_member",
      render: (val) => valueOrNa(val?.name),
    },
    // {
    //   title: "Start Date",
    //   align: "center",
    //   dataIndex: "startDate",
    //   render: (val) => valueOrNa(val),
    // },
    // {
    //   title: "End Date",
    //   align: "center",
    //   dataIndex: "endDate",
    //   render: (val) => valueOrNa(val),
    // },

    {
      title: "Task Complete",
      align: "center",
      dataIndex: "response_count",
      render: (val) => valueOrNa(val),
    },
    // {
    //   title: "Total Payable (৳)",
    //   align: "center",
    //   dataIndex: "totalPayable",
    //   render: (val) => valueOrNa(val),
    // },
    // {
    //   title: "Good Status",
    //   align: "center",
    //   dataIndex: "goodStatus",
    //   render: (val: string) => {
    //     return <span>{capitalize(val)}</span>;
    //   },
    // },
    // {
    //   title: "Payment Status",
    //   align: "center",
    //   dataIndex: "status",
    //   render: (val: string) => {
    //     return (
    //       <span className={STATUS_CONFIG[val as keyof typeof STATUS_CONFIG]}>
    //         {capitalize(val)}
    //       </span>
    //     );
    //   },
    // },
    {
      title: "Action",
      align: "center",
      width: 130,
      render: (val) => {
        return (
          <Link
            to={`/organizations/survey/templates/survey-data-details/${id}/${val.business_member_id}?bondhu=${val?.business_member?.name}`}
          >
            <Button
              size="small"
              className="w-full bg-[#F2F5FF] !text-[#1B4DFF] border:none hover:bg-[#F2F5FF] hover:border-[#1B4DFF]"
            >
              View Task
            </Button>
          </Link>
        );
      },
    },
  ];

  return (
    <>
      <SidebarLayout title="Survey">
        <TitleBar
          title="Survey Details"
          backLink="/organizations/survey/survey-data-list"
        />

        <CustomTable
          loading={isLoading || isFetching}
          limit={limit}
          page={page}
          columns={columns}
          total={data?.data?.total}
          dataSource={addKeyInArray(surveyData)}
          handleLimit={handleLimit}
          handlePagination={handlePagination}
          filterSection={
            <>
              {/* <Input
                suffix={<SearchIcon />}
                placeholder="Search"
                style={{ minWidth: 170, maxWidth: 180 }}
                onChange={(val) => handleSearch(val)}
              />

              <Select
                allowClear
                showSearch
                placeholder="Status"
                filterOption={selectSearchOption}
                options={statusList}
                className="min-w-[90px]"
                suffixIcon={<SelectDownIcon />}
                rootClassName="icon-gray"
                value={filter.status}
                onChange={(val) => handleFilter("status", val)}
                popupMatchSelectWidth={120}
              /> */}
            </>
          }
        />
      </SidebarLayout>
    </>
  );
}
